// extracted by mini-css-extract-plugin
export default {"flavor_option":"TV","out_of_stock_text":"UV","out_of_stock":"VV","flavor_option_image":"WV","flavor_option_info":"XV","flavor_option_title":"YV","flavor_option_limited":"ZV","flavor_option_amount_wrapper":"aW","flavor_option_amount_button":"bW","zero_amount":"cW","no_flavors":"eW","no_flavors_active":"fW","flavor_option_select_wrapper":"gW","flavor_option_select_wrapper__selected":"hW"};
    if(module.hot) {
      // 1713969936745
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  